import React from "react";
import { Flex, Form } from "antd";

import { _greaterOrEqual, _isNumber, _isIntegerInRange, _isInteger } from "utils/form/simple-validation";
import { DefaultInput } from "../DefaultInput";
import { FORM_VALIDATION_DEBOUNCE } from "constants/form";

interface IProps {
  disabled?: boolean;
  hidden?: boolean;
  id?: string;
}

export const ExpTimeInput: React.FC<IProps> = ({ disabled = false, hidden = false, id }) => {
  return (
    <Flex justify="space-between" gap="small" id={id} hidden={hidden}>
      <Form.Item
        name="hours"
        rules={[_isNumber(), _greaterOrEqual(0), _isInteger()]}
        validateDebounce={FORM_VALIDATION_DEBOUNCE}
        className="full-width"
        hidden={hidden}
      >
        <DefaultInput placeholder="Часы" disabled={disabled} />
      </Form.Item>
      <Form.Item
        name="minutes"
        rules={[_isIntegerInRange(0, 60, "Введите целое число до 60")]}
        validateDebounce={FORM_VALIDATION_DEBOUNCE}
        className="full-width"
        hidden={hidden}
      >
        <DefaultInput placeholder="Минуты" disabled={disabled} />
      </Form.Item>
    </Flex>
  );
};
